import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Logo } from './Logo';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Why Us',
    href: '#why-us'
  }, {
    name: 'Testimonials',
    href: '#testimonials'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-navy py-3 shadow-lg' : 'bg-transparent py-5'}`} data-id="element-182">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-183">
        <div className="flex justify-between items-center" data-id="element-184">
          <a href="#" className="z-50 block" data-id="element-185">
            <div className="bg-white/95 backdrop-blur-sm rounded-lg px-4 py-2 shadow-md" data-id="element-186">
              <Logo size="lg" data-id="element-187" />
            </div>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-188">
            <ul className="flex gap-6" data-id="element-189">
              {navLinks.map(link => <li key={link.name} data-id="element-190">
                  <a href={link.href} className={`text-sm font-medium transition-colors hover:text-gold ${isScrolled ? 'text-white' : 'text-white/90 drop-shadow-md'}`} data-id="element-191">
                    {link.name}
                  </a>
                </li>)}
            </ul>
            <a href="#contact" className="bg-gold hover:bg-gold-light text-navy font-semibold px-6 py-2.5 rounded text-sm transition-colors shadow-md" data-id="element-192">
              Get a Free Quote
            </a>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden z-50 text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-193">
            {isMobileMenuOpen ? <X size={28} data-id="element-194" /> : <Menu size={28} className={!isScrolled ? 'drop-shadow-md' : ''} data-id="element-195" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      <div className={`fixed inset-0 bg-navy z-40 flex flex-col justify-center items-center transition-transform duration-300 ease-in-out ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'} md:hidden`} data-id="element-196">
        <ul className="flex flex-col gap-6 items-center text-center" data-id="element-197">
          {navLinks.map(link => <li key={link.name} data-id="element-198">
              <a href={link.href} className="text-white text-2xl font-serif hover:text-gold transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-199">
                {link.name}
              </a>
            </li>)}
          <li className="mt-4" data-id="element-200">
            <a href="#contact" className="bg-gold text-navy font-semibold px-8 py-3 rounded text-lg transition-colors inline-block" onClick={() => setIsMobileMenuOpen(false)} data-id="element-201">
              Get a Free Quote
            </a>
          </li>
        </ul>
      </div>
    </header>;
}